import { render, staticRenderFns } from "./ConfirmationLayout.vue?vue&type=template&id=2d5e850b&"
import script from "./ConfirmationLayout.vue?vue&type=script&lang=js&"
export * from "./ConfirmationLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports